import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { type FlowTagCategory } from 'flow-schema';
import { startCase } from 'lodash';
import { useId } from 'react';

import { Text, isTruthy } from 'common';

import { FlowTemplateFilterGroup, type FlowTemplateFilterGroupState } from './FilterGroup';
import { EventAction, EventCategory, useCaptureEvents } from '../../../../../utils/events/index';
import { sortFlowTemplateTagNames } from '../utils';

interface FlowTemplateTagFiltersProps {
  tags: Set<string> | undefined;
  sectionLabel: string;
  tagCategory: FlowTagCategory;
  selectedTags: Set<string>;
  setSelectedTags: (selectedTags: Set<string>) => void;
  sectionState: FlowTemplateFilterGroupState;
  onSectionStateChange: (state: FlowTemplateFilterGroupState) => void;
}

export function FlowTemplateTagFilters(props: FlowTemplateTagFiltersProps) {
  const {
    tags,
    sectionLabel,
    tagCategory,
    selectedTags,
    setSelectedTags,
    sectionState,
    onSectionStateChange,
  } = props;
  const id = useId();
  const { captureEvent } = useCaptureEvents();

  if (!isTruthy(tags?.size)) {
    return null;
  }

  return (
    <FlowTemplateFilterGroup
      label={sectionLabel}
      state={sectionState}
      onStateChange={onSectionStateChange}
    >
      <FormGroup id={id}>
        {[...tags].sort(sortFlowTemplateTagNames).map((tag) => {
          return (
            <FormControlLabel
              key={tag}
              control={
                <Checkbox
                  size="small"
                  checked={selectedTags.has(tag)}
                  onChange={(event) => {
                    const isChecked = event.target.checked;
                    if (isChecked) {
                      setSelectedTags(new Set(selectedTags).add(tag));
                    } else {
                      const newSet = new Set(selectedTags);
                      newSet.delete(tag);
                      setSelectedTags(newSet);
                    }
                    captureEvent({
                      category: EventCategory.FlowDefinitionTemplate,
                      action: EventAction.FilterClick,
                      properties: {
                        tagName: tag,
                        tagCategory,
                        isChecked,
                      },
                    });
                  }}
                />
              }
              label={<Text variant="body2">{startCase(tag)}</Text>}
            />
          );
        })}
      </FormGroup>
    </FlowTemplateFilterGroup>
  );
}
